import { io } from 'socket.io-client';
import { createContext } from 'react';

export const createSocket = () => {
    let token = ''
    if (localStorage.getItem('user')) {
        token = JSON.parse(localStorage.getItem('user')).token;
    }
    const socket = io('',{
        path: '/ws/socket.io',
        auth: {
            token: token
        }
    });
    return socket;
}

export const WebSocketContext = createContext(null);